import React from 'react';
import { CheckCircle2, Lightbulb, Palette, Code, Rocket, Brain, MessageSquare, Eye, Sparkles, Zap, Users, RefreshCw, Shield } from 'lucide-react';

const iconMap = { Lightbulb, Palette, Code, Rocket, Brain, MessageSquare, Eye, Sparkles, Zap, Users, RefreshCw, Shield };

const ServiceContent = ({ data }) => {
  return (
    <>
      {/* Sections */}
      {data.sections.map((section, sectionIndex) => (
        <section key={sectionIndex} className="py-20 md:py-28" style={{ background: sectionIndex % 2 === 0 ? '#FFFFFF' : '#F8FAFC' }}>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="mb-14">
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 font-heading mb-4">
                {section.heading}
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {section.items.map((item, index) => {
                const IconComponent = iconMap[item.icon] || Code;
                return (
                  <div
                    key={index}
                    className="card-lift bg-white rounded-2xl p-7 border border-slate-100 group"
                    style={{ boxShadow: '0 1px 4px rgba(0,0,0,0.04)' }}
                  >
                    <div className="flex items-start gap-4 mb-3">
                      <div className="w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0" style={{ background: 'rgba(38,147,255,0.08)' }}>
                        <IconComponent className="w-5 h-5" style={{ color: '#2693FF' }} />
                      </div>
                      <h3 className="text-xl font-bold text-slate-900 font-heading group-hover:text-[#2693FF] transition-colors">
                        {item.title}
                      </h3>
                    </div>
                    <p className="text-sm text-slate-500 leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      ))}

      {/* Capabilities */}
      <section className="py-20 md:py-28" style={{ background: '#F8FAFC' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            <div>
              <p className="text-sm font-semibold uppercase tracking-widest mb-3 font-heading" style={{ color: '#2693FF' }}>
                Capabilities
              </p>
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 font-heading mb-5">
                What we deliver
              </h2>
              <p className="text-lg text-slate-500 leading-relaxed">
                Comprehensive services to bring your vision to life with quality and expertise.
              </p>
            </div>

            <div className="space-y-3">
              {data.capabilities.map((capability, index) => (
                <div
                  key={index}
                  className="flex items-start gap-4 p-4 rounded-xl border border-slate-100 bg-white hover:border-slate-200 transition-all duration-200"
                  style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.03)' }}
                >
                  <CheckCircle2 className="w-5 h-5 flex-shrink-0 mt-0.5" style={{ color: '#2693FF' }} />
                  <span className="text-slate-700">{capability}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Technologies */}
      <section className="py-20 md:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-sm font-semibold uppercase tracking-widest mb-3 font-heading" style={{ color: '#2693FF' }}>
            Tech Stack
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 font-heading mb-10">
            Technologies we use
          </h2>
          <div className="flex flex-wrap justify-center gap-3">
            {data.technologies.map((tech, index) => (
              <span
                key={index}
                className="px-5 py-2.5 rounded-full border border-slate-200 bg-white text-slate-700 text-sm font-medium hover:border-[#2693FF] hover:text-[#2693FF] transition-colors cursor-default"
              >
                {tech}
              </span>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default ServiceContent;
